<template>
    <AppLayout>
        <div class="container p-4 mx-auto md:px-1 md:py-4">
            <!-- breadcrumb -->
            <nav
                class="mb-6 text-sm font-semibold"
                aria-label="Breadcrumb"
            >
                <ol class="inline-flex p-0 list-none">
                    <li class="flex items-center text-blue-500">
                        <inertia-link
                            :href="route('landing')"
                            class="text-gray-600"
                        >
                            {{ $t('LBL_HOME') }}
                        </inertia-link>
                        <svg
                            fill="#34D399"
                            class="w-3 h-3 mx-3 "
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path
                                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                            />
                        </svg>
                    </li>
                    <li class="flex items-center">
                        <a
                            href="#"
                            class="text-gray-600"
                        >
                            {{ $t('LBL_DASHBOARD') }}
                        </a>
                    </li>
                </ol>
            </nav>
            <!-- breadcrumb end -->

            <!-- filter for Count Cards -->
            <div class="items-center justify-between mb-6 lg:flex">
                <p class="mb-2 text-xl font-semibold lg:mb-0">
                    {{ greetings }} {{ $page.props.user.name }}!
                </p>
                <div class="flex items-center justify-end xsm:justify-center">
                    <div>
                        <t-select
                            v-if="!isRetailer"
                            v-model="filterBy"
                            :options="filterByOptions"
                            text-attribute="name"
                            value-attribute="value"
                        />
                    </div>
                </div>
            </div>

            <!-- Count Cards  -->
            <div
                v-if="!isRetailer"
                class="grid grid-cols-1 gap-3 my-6 mb-10 md:grid-cols-4 lg:grid-cols-4"
            >
                <!-- Kyc Card -->
                <div
                    v-if="isAdmin"
                    class="w-full p-3 bg-white border rounded-md shadow-md cursor-pointer"
                    @click="goto('kyc.index')"
                >
                    <div class="flex items-center">
                        <AdminIcon
                            class="w-10 mr-3"
                            fill="#34D399"
                        />
                        <div class="flex flex-col flex-grow text-gray-700">
                            <p class="text-3xl font-semibold">
                                {{ allDetails.userCount.pendingKycCount }}
                            </p>
                            <p>
                                {{ $t('TXT_PENDING_KYC') }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Wholesaler Card -->
                <div
                    v-if="isAdmin"
                    class="w-full p-3 bg-white border rounded-md shadow-md cursor-pointer"
                    @click="goto('users.management.index')"
                >
                    <div class="flex items-center">
                        <WholesalerIcon
                            class="w-10 mr-3"
                            fill="#34D399"
                        />
                        <div class="flex flex-col flex-grow text-gray-700">
                            <p class="text-3xl font-semibold">
                                {{ allDetails.userCount.wholesalerCount }}
                            </p>
                            <p>
                                {{ $tc('TXT_WHOLESALER', 2) }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Retailer Card -->
                <div
                    v-if="isAdmin"
                    class="w-full p-3 bg-white border rounded-md shadow-md cursor-pointer"
                    @click="goto('users.management.retailer.index')"
                >
                    <div class="flex items-center">
                        <RetailerIcon
                            class="w-10 mr-3"
                            fill="#34D399"
                        />
                        <div class="flex flex-col flex-grow text-gray-700">
                            <p class="text-3xl font-semibold">
                                {{ allDetails.userCount.retailerCount }}
                            </p>
                            <p>
                                {{ $tc('TXT_RETAILER', 2) }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Products Card -->
                <div
                    v-if="!isRetailer"
                    class="w-full p-3 bg-white border rounded-md shadow-md cursor-pointer"
                    @click="goto('products.index')"
                >
                    <div class="flex items-center">
                        <ProductIcon
                            class="w-10 mr-3"
                            fill="#34D399"
                        />
                        <div class="flex flex-col flex-grow text-gray-700">
                            <p class="text-3xl font-semibold">
                                {{ allDetails.productCount }}
                            </p>
                            <p>
                                {{ $tc('TXT_PRODUCT', 2) }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Categories Card -->
                <div
                    v-if="!isRetailer"
                    class="w-full p-3 bg-white border rounded-md shadow-md cursor-pointer"
                    @click="goto('categories.index')"
                >
                    <div class="flex items-center">
                        <CategoryIcon
                            class="w-8 mr-3"
                            fill="#34D399"
                        />
                        <div class="flex flex-col flex-grow text-gray-700">
                            <p class="text-3xl font-semibold">
                                {{ allDetails.categoryCount }}
                            </p>
                            <p>
                                {{ $tc('TXT_CATEGORY', 2) }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Brands Card -->
                <div
                    v-if="isWholesaler"
                    class="w-full p-3 bg-white border rounded-md shadow-md cursor-pointer"
                    @click="goto('brands.index')"
                >
                    <div class="flex items-center">
                        <BrandIcon
                            class="w-10 mr-3"
                            fill="#34D399"
                        />
                        <div class="flex flex-col flex-grow text-gray-700">
                            <p class="text-3xl font-semibold">
                                {{ allDetails.brandCount }}
                            </p>
                            <p>
                                {{ $tc('TXT_BRAND', 2) }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Salesperson Card -->
                <div
                    v-if="isAdmin"
                    class="w-full p-3 bg-white border rounded-md shadow-md cursor-pointer"
                >
                    <div class="flex items-center">
                        <PeopleIcon
                            class="w-10 mr-3"
                            fill="#34D399"
                        />
                        <div class="flex flex-col flex-grow text-gray-700">
                            <p class="text-3xl font-semibold">
                                {{ allDetails.salesPersonCount }}
                            </p>
                            <p>
                                {{ $tc('TXT_SALESPERSON', 2) }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Pending Credit Request Card -->
                <div
                    v-if="!isRetailer"
                    class="w-full p-3 bg-white border rounded-md shadow-md cursor-pointer"
                    @click="goto('creditRequest.index')"
                >
                    <div class="flex items-center">
                        <BrandIcon
                            class="w-10 mr-3"
                            fill="#34D399"
                        />
                        <div class="flex flex-col flex-grow text-gray-700">
                            <p class="text-3xl font-semibold">
                                {{ allDetails.creditRequestCount }}
                            </p>
                            <p>
                                {{ $t('TXT_PENDING_CREDIT_REQUEST') }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Complains Card -->
                <div
                    v-if="isAdmin"
                    class="w-full p-3 bg-white border rounded-md shadow-md cursor-pointer"
                    @click="goto('complains.index')"
                >
                    <div class="flex items-center">
                        <ClockIcon
                            class="w-10 mr-3"
                            fill="#34D399"
                        />
                        <div class="flex flex-col flex-grow text-gray-700">
                            <p class="text-3xl font-semibold">
                                {{ allDetails.complainCount }}
                            </p>
                            <p>
                                {{ $tc('TXT_COMPLAIN', 2) }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Recent Order Table for Admin -->
            <div
                v-if="isAdmin"
                class="my-10"
            >
                <div class="mb-4 text-xl font-semibold lg:text-xl">
                    {{ $t('LBL_RECENT_ORDERS') }}
                </div>

                <div class="p-0 max-w-full bg-white rounded border shadow-md sm:p-0 dark:bg-gray-800 dark:border-gray-700">
                    <t-table
                        :responsive="true"
                        :responsive-breakpoint="640"
                        :headers="['RETAILER', 'PRODUCT SOLD', 'AMOUNT', 'STATUS', 'TRANSACTION']"
                        :data="groupedBills()"
                    >
                        <template
                            slot="tbody"
                            slot-scope="{ tbodyClass, trClass, tdClass, renderResponsive, data, headers }"
                        >
                            <template v-if="renderResponsive">
                                <tbody
                                    v-for="(row, rowIndex) in data[4]"
                                    :key="rowIndex"
                                    :class="[tbodyClass, rowIndex % 2 === 0 ? 'bg-gray-100' : '']"
                                >
                                    <tr
                                        v-for="header in headers"
                                        :key="header.text"
                                        :class="trClass"
                                    >
                                        <th class="pl-1 text-sm font-semibold text-left text-gray-600 uppercase">
                                            {{ header.text }}
                                        </th>

                                        <td :class="[tdClass, 'relative']">
                                            <div v-if="header.text === 'Index'">
                                                {{ rowIndex + 1 + (currentPage - 1) * perPage }}
                                            </div>
                                            <div
                                                v-if="header.text === 'Image'"
                                                class="h-24"
                                            >
                                                <img
                                                    v-if="row.images.length"
                                                    class="object-cover w-24 h-full"
                                                    :src="row.images[0].image_path"
                                                    :alt="row.name"
                                                >
                                                <img
                                                    v-else
                                                    :src="
                                                        `https://ui-avatars.com/api/?name=${row.name}&color=7F9CF5&background=EBF4FF`
                                                    "
                                                    class="object-contain h-full"
                                                    :alt="row.name"
                                                >
                                            </div>
                                            <div v-if="header.text === 'Name'">
                                                {{ row.name }}
                                            </div>
                                            <div v-if="header.text === 'Brand'">
                                                {{ (row.brand && row.brand.name) || 'No Brand' }}
                                            </div>
                                            <div v-if="header.text === 'Price'">
                                                {{ config(common.currency, product && product.owner) }}
                                                {{ parseFloat(row.price).toFixed(2) }}
                                            </div>
                                            <div v-if="header.text === 'Category'">
                                                {{ row.category_name }}
                                            </div>
                                            <div v-if="header.text === 'Stock'">
                                                {{ row.available_stock }}
                                            </div>

                                            <div
                                                v-if="header.text === 'Actions'"
                                                class="flex flex-wrap items-center gap-1"
                                            >
                                                <Button
                                                    text="Show"
                                                    @onClick="
                                                        newTab('products.show', {
                                                            dummy: `${convertToKebabCase(
                                                                row.brand.name,
                                                            )}-${convertToKebabCase(row.name)}`,
                                                            product: row.slug,
                                                        })
                                                    "
                                                >
                                                    <template slot="icon">
                                                        <ViewIcon class="w-3 fill-current" />
                                                    </template>
                                                </Button>

                                                <Button
                                                    text="Edit"
                                                    color="green"
                                                    @onClick="editProduct(row.id)"
                                                >
                                                    <template slot="icon">
                                                        <EditIcon class="w-3 fill-current" />
                                                    </template>
                                                </Button>

                                                <Button
                                                    text="Delete"
                                                    color="red"
                                                    @onClick="deleteProduct(row.id)"
                                                >
                                                    <template slot="icon">
                                                        <DeleteIcon class="w-4 fill-current" />
                                                    </template>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </template>

                        <template
                            slot="tbody"
                            slot-scope="props"
                        >
                            <tbody :class="props.tbodyClass">
                                <!-- today title -->
                                <tr
                                    v-if="props.data[0].length"
                                    :class="props.trClass"
                                    class="font-bold"
                                >
                                    <td
                                        :class="props.tdClass"
                                        :colspan="5"
                                    >
                                        <p>Today</p>
                                    </td>
                                </tr>
                                <!-- today's bills -->
                                <tr
                                    v-for="bill in props.data[0]"
                                    :key="'bill-' + bill.id"
                                    :class="[trClass, bill.delivery_status === 'Placed' ? 'bg-red-100' :
                                        bill.delivery_status === 'Packed' ? 'bg-yellow-100' :
                                        bill.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-green-100']"
                                    class="cursor-pointer "
                                    @click="goto('account.show', { orderId: bill.bill_number })"
                                >
                                    <!-- wholesaler name -->
                                    <!-- <td :class="props.tdClass">
                                    {{ bill.wholesaler.name }}
                                </td> -->
                                    <!-- Retailer Name -->
                                    <td :class="props.tdClass">
                                        {{ bill.user.name }}
                                    </td>
                                    <!-- transaction count -->
                                    <td :class="props.tdClass">
                                        {{ bill.transactions.length }}
                                    </td>
                                    <!-- total transaction amount -->
                                    <td :class="[props.tdClass, 'text-green-600 font-semibold']">
                                        {{ config(common.currency) }} {{ sumAmountFromTransactions(bill.transactions) }}
                                    </td>
                                    <!-- Order Status  -->
                                    <td :class="props.tdClass">
                                        <div
                                            :class="bill.delivery_status === 'Placed' ? 'bg-red-400' :
                                                bill.delivery_status === 'Packed' ? 'bg-yellow-400' :
                                                bill.delivery_status === 'Shipped' ? 'bg-blue-400' : 'bg-green-400'"
                                            class="inline-block px-2 py-1 mt-1 text-sm text-white rounded"
                                        >
                                            {{ bill.delivery_status }}
                                        </div>
                                    </td>
                                    <!-- Date  -->
                                    <td :class="props.tdClass">
                                        {{ bill.created_at | fromNow }}
                                    </td>
                                </tr>

                                <!-- yesterday title -->
                                <tr
                                    v-if="props.data[1].length"
                                    :class="props.trClass"
                                    class="font-bold"
                                >
                                    <td
                                        :class="props.tdClass"
                                        :colspan="5"
                                    >
                                        Yesterday
                                    </td>
                                </tr>
                                <!-- yesterday's bills -->
                                <tr
                                    v-for="bill in props.data[1]"
                                    :key="'bill-' + bill.id"
                                    :class="[trClass, bill.delivery_status === 'Placed' ? 'bg-red-100' :
                                        bill.delivery_status === 'Packed' ? 'bg-yellow-100' :
                                        bill.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-green-100']"
                                    class="cursor-pointer"
                                    @click="goto('account.show', { orderId: bill.bill_number })"
                                >
                                    <!-- wholesaler name -->
                                    <!-- <td :class="props.tdClass">
                                    {{ bill.wholesaler.name }}
                                </td> -->
                                    <!-- Retailer Name -->
                                    <td :class="props.tdClass">
                                        {{ bill.user.name }}
                                    </td>
                                    <!-- transaction count -->
                                    <td :class="props.tdClass">
                                        {{ bill.transactions.length }}
                                    </td>
                                    <!-- total transaction amount -->
                                    <td :class="[props.tdClass, 'text-green-500 font-semibold']">
                                        {{ config(common.currency) }} {{ sumAmountFromTransactions(bill.transactions) }}
                                    </td>
                                    <!-- Order Status  -->
                                    <td :class="props.tdClass">
                                        <div
                                            :class="bill.delivery_status === 'Placed' ? 'bg-red-400' :
                                                bill.delivery_status === 'Packed' ? 'bg-yellow-400' :
                                                bill.delivery_status === 'Shipped' ? 'bg-blue-400' : 'bg-green-400'"
                                            class="inline-block px-2 py-1 mt-1 text-sm text-white rounded"
                                        >
                                            {{ bill.delivery_status }}
                                        </div>
                                    </td>
                                    <!-- Date  -->
                                    <td :class="props.tdClass">
                                        {{ bill.created_at | fromNow }}
                                    </td>
                                </tr>

                                <!-- this week title -->
                                <tr
                                    v-if="props.data[2].length"
                                    :class="props.trClass"
                                    class="font-bold"
                                >
                                    <td
                                        :class="props.tdClass"
                                        :colspan="5"
                                    >
                                        This Week
                                    </td>
                                </tr>
                                <!-- this week's bills -->
                                <tr
                                    v-for="bill in props.data[2]"
                                    :key="'bill-' + bill.id"
                                    :class="[trClass, bill.delivery_status === 'Placed' ? 'bg-red-100' :
                                        bill.delivery_status === 'Packed' ? 'bg-yellow-100' :
                                        bill.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-green-100']"
                                    class="cursor-pointer"
                                    @click="goto('account.show', { orderId: bill.bill_number })"
                                >
                                    <!-- wholesaler name -->
                                    <!-- <td :class="props.tdClass">
                                    {{ bill.wholesaler.name }}
                                </td> -->
                                    <!-- Retailer Name -->
                                    <td :class="props.tdClass">
                                        {{ bill.user.name }}
                                    </td>
                                    <!-- transaction count -->
                                    <td :class="props.tdClass">
                                        {{ bill.transactions.length }}
                                    </td>
                                    <!-- total transaction amount -->
                                    <td :class="[props.tdClass, 'text-green-500 font-semibold']">
                                        {{ config(common.currency) }} {{ sumAmountFromTransactions(bill.transactions) }}
                                    </td>
                                    <!-- Order Status  -->
                                    <td :class="props.tdClass">
                                        <div
                                            :class="bill.delivery_status === 'Placed' ? 'bg-red-400' :
                                                bill.delivery_status === 'Packed' ? 'bg-yellow-400' :
                                                bill.delivery_status === 'Shipped' ? 'bg-blue-400' : 'bg-green-400'"
                                            class="inline-block px-2 py-1 mt-1 text-sm text-white rounded"
                                        >
                                            {{ bill.delivery_status }}
                                        </div>
                                    </td>
                                    <!-- Date  -->
                                    <td :class="props.tdClass">
                                        {{ bill.created_at | fromNow }}
                                    </td>
                                </tr>

                                <!-- last week title -->
                                <tr
                                    v-if="props.data[3].length"
                                    :class="props.trClass"
                                    class="font-bold"
                                >
                                    <td
                                        :class="props.tdClass"
                                        :colspan="5"
                                    >
                                        Last Week
                                    </td>
                                </tr>
                                <!-- last week's bills -->
                                <tr
                                    v-for="bill in props.data[3]"
                                    :key="'bill-' + bill.id"
                                    :class="[trClass, bill.delivery_status === 'Placed' ? 'bg-red-100' :
                                        bill.delivery_status === 'Packed' ? 'bg-yellow-100' :
                                        bill.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-green-100']"
                                    class="cursor-pointer"
                                    @click="goto('account.show', { orderId: bill.bill_number })"
                                >
                                    <!-- wholesaler name -->
                                    <!-- <td :class="props.tdClass">
                                    {{ bill.wholesaler.name }}
                                </td> -->
                                    <!-- Retailer Name -->
                                    <td :class="props.tdClass">
                                        {{ bill.user.name }}
                                    </td>
                                    <!-- transaction count -->
                                    <td :class="props.tdClass">
                                        {{ bill.transactions.length }}
                                    </td>
                                    <!-- total transaction amount -->
                                    <td :class="[props.tdClass, 'text-green-500 font-semibold']">
                                        {{ config(common.currency) }} {{ sumAmountFromTransactions(bill.transactions) }}
                                    </td>
                                    <!-- Order Status  -->
                                    <td :class="props.tdClass">
                                        <div
                                            :class="bill.delivery_status === 'Placed' ? 'bg-red-400' :
                                                bill.delivery_status === 'Packed' ? 'bg-yellow-400' :
                                                bill.delivery_status === 'Shipped' ? 'bg-blue-400' : 'bg-green-400'"
                                            class="inline-block px-2 py-1 mt-1 text-sm text-white rounded"
                                        >
                                            {{ bill.delivery_status }}
                                        </div>
                                    </td>
                                    <!-- Date  -->
                                    <td :class="props.tdClass">
                                        {{ bill.created_at | fromNow }}
                                    </td>
                                </tr>

                                <!-- past title -->
                                <tr
                                    v-if="props.data[4].length"
                                    :class="props.trClass"
                                    class="font-bold"
                                >
                                    <td
                                        :class="props.tdClass"
                                        :colspan="5"
                                    >
                                        Past
                                    </td>
                                </tr>
                                <!-- past bills -->
                                <tr
                                    v-for="bill in props.data[4]"
                                    :key="'bill-' + bill.id"
                                    :class="[trClass, bill.delivery_status === 'Placed' ? 'bg-red-100' :
                                        bill.delivery_status === 'Packed' ? 'bg-yellow-100' :
                                        bill.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-green-100']"
                                    class="cursor-pointer"
                                    @click="goto('account.show', { orderId: bill.bill_number })"
                                >
                                    <!-- wholesaler name -->
                                    <!-- <td :class="props.tdClass">
                                    {{ bill.wholesaler.name }}
                                </td> -->
                                    <!-- Retailer Name -->
                                    <td :class="props.tdClass">
                                        {{ bill.user.name }}
                                    </td>
                                    <!-- transaction count -->
                                    <td :class="props.tdClass">
                                        {{ bill.transactions.length }}
                                    </td>
                                    <!-- total transaction amount -->
                                    <td :class="[props.tdClass, 'text-green-500 font-semibold']">
                                        {{ config(common.currency) }} {{ sumAmountFromTransactions(bill.transactions) }}
                                    </td>
                                    <!-- Order Status  -->
                                    <td :class="props.tdClass">
                                        <div
                                            :class="bill.delivery_status === 'Placed' ? 'bg-red-400' :
                                                bill.delivery_status === 'Packed' ? 'bg-yellow-400' :
                                                bill.delivery_status === 'Shipped' ? 'bg-blue-400' : 'bg-green-400'"
                                            class="inline-block px-2 py-1 mt-1 text-sm text-white rounded"
                                        >
                                            {{ bill.delivery_status }}
                                        </div>
                                    </td>
                                    <!-- Date  -->
                                    <td :class="props.tdClass">
                                        {{ bill.created_at | fromNow }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </t-table>
                    <div
                        v-if="!allDetails.bills.length"
                        class="my-10 w-100 text-center"
                    >
                        {{ $t('LBL_DATA_FOUND') }}
                    </div>
                </div>
            </div>

            <div
                v-if="isWholesaler"
                class="my-10"
            >
                <div class="mb-4 font-semibold md:text-xl">
                    {{ $t('TXT_RECENT_ORDER') }}
                </div>

                <div class="p-0 max-w-full bg-white rounded border shadow-md sm:p-0 dark:bg-gray-800 dark:border-gray-700">
                    <t-table
                        :responsive="true"
                        :responsive-breakpoint="640"
                        :headers="['RETAILER NAME', 'PRODUCT SOLD', 'AMOUNT', 'STATUS', 'TRANSACTION DATE']"
                        :data="groupedBills()"
                        class="text-xs md:text-sm border-none shadow-none"
                    >
                        <template
                            slot="tbody"
                            slot-scope="{ tbodyClass, trClass, tdClass, renderResponsive, data, headers }"
                        >
                            <template v-if="renderResponsive">
                                <!-- today's title -->
                                <div
                                    v-if="data[0].length"
                                    class="pt-2 pb-2 pl-2 font-bold"
                                >
                                    {{ $t('LBL_TODAY') }}
                                </div>
                                <!-- today's bills -->
                                <tbody
                                    v-for="(row, rowIndex) in data[0]"
                                    :key="rowIndex"
                                    :class="[tbodyClass, rowIndex % 2 === 0 ? 'bg-gray-200' : '']"
                                >
                                    <tr
                                        v-for="header in headers"
                                        :key="header.text"
                                        :class="trClass"
                                        @click="goto('account.show', { orderId: row.bill_number })"
                                    >
                                        <th class="pl-1 text-sm font-semibold text-left text-gray-600 uppercase">
                                            {{ header.text }}
                                        </th>

                                        <td :class="[tdClass, 'relative']">
                                            <div v-if="header.text === 'Retailer Name'">
                                                {{ row.user.name }}
                                            </div>
                                            <div v-if="header.text === 'Items Sold'">
                                                {{ row.transactions.length }}
                                            </div>
                                            <div v-if="header.text === 'Sales Amount'">
                                                {{ config(common.currency) }}
                                                {{ sumAmountFromTransactions(row.transactions) }}
                                            </div>
                                            <div v-if="header.text === 'Date'">
                                                {{ row.created_at | fromNow }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <!-- yesterday title -->
                                <div
                                    v-if="data[1].length"
                                    class="pt-2 pb-2 pl-2 font-bold"
                                >
                                    {{ $t('LBL_YESTERDAY') }}
                                </div>
                                <!-- yesterday's bills -->
                                <tbody
                                    v-for="(row, rowIndex) in data[1]"
                                    :key="rowIndex"
                                    :class="[tbodyClass, rowIndex % 2 === 0 ? 'bg-gray-200' : '']"
                                >
                                    <tr
                                        v-for="header in headers"
                                        :key="header.text"
                                        :class="trClass"
                                        @click="goto('account.show', { orderId: row.bill_number })"
                                    >
                                        <th class="pl-1 text-sm font-semibold text-left text-gray-600 uppercase">
                                            {{ header.text }}
                                        </th>

                                        <td :class="[tdClass, 'relative']">
                                            <div v-if="header.text === 'Retailer Name'">
                                                {{ row.user.name }}
                                            </div>
                                            <div v-if="header.text === 'Items Sold'">
                                                {{ row.transactions.length }}
                                            </div>
                                            <div v-if="header.text === 'Sales Amount'">
                                                {{ config(common.currency) }}
                                                {{ sumAmountFromTransactions(row.transactions) }}
                                            </div>
                                            <div v-if="header.text === 'Date'">
                                                {{ row.created_at | fromNow }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <!-- this week title -->
                                <div
                                    v-if="data[2].length"
                                    class="pt-2 pb-2 pl-2 font-bold"
                                >
                                    {{ $t('LBL_THIS_WEEK') }}
                                </div>
                                <!-- the week's bills -->
                                <tbody
                                    v-for="(row, rowIndex) in data[2]"
                                    :key="rowIndex"
                                    :class="[tbodyClass, rowIndex % 2 === 0 ? 'bg-gray-200' : '']"
                                >
                                    <tr
                                        v-for="header in headers"
                                        :key="header.text"
                                        :class="trClass"
                                        @click="goto('account.show', { orderId: row.bill_number })"
                                    >
                                        <th class="pl-1 text-sm font-semibold text-left text-gray-600 uppercase">
                                            {{ header.text }}
                                        </th>

                                        <td :class="[tdClass, 'relative']">
                                            <div v-if="header.text === 'Retailer Name'">
                                                {{ row.user.name }}
                                            </div>
                                            <div v-if="header.text === 'Items Sold'">
                                                {{ row.transactions.length }}
                                            </div>
                                            <div v-if="header.text === 'Sales Amount'">
                                                {{ config(common.currency) }}
                                                {{ sumAmountFromTransactions(row.transactions) }}
                                            </div>
                                            <div v-if="header.text === 'Date'">
                                                {{ row.created_at | fromNow }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <!-- last week title -->
                                <div
                                    v-if="data[3].length"
                                    class="pt-2 pb-2 pl-2 font-bold"
                                >
                                    {{ $t('LBL_LAST_WEEK') }}
                                </div>
                                <!-- last week's bills -->
                                <tbody
                                    v-for="(row, rowIndex) in data[3]"
                                    :key="rowIndex"
                                    :class="[tbodyClass, rowIndex % 2 === 0 ? 'bg-gray-200' : '']"
                                >
                                    <tr
                                        v-for="header in headers"
                                        :key="header.text"
                                        :class="trClass"
                                        @click="goto('account.show', { orderId: row.bill_number })"
                                    >
                                        <th class="pl-1 text-sm font-semibold text-left text-gray-600 uppercase">
                                            {{ header.text }}
                                        </th>

                                        <td :class="[tdClass, 'relative']">
                                            <div v-if="header.text === 'Retailer Name'">
                                                {{ row.user.name }}
                                            </div>
                                            <div v-if="header.text === 'Items Sold'">
                                                {{ row.transactions.length }}
                                            </div>
                                            <div v-if="header.text === 'Sales Amount'">
                                                {{ config(common.currency) }}
                                                {{ sumAmountFromTransactions(row.transactions) }}
                                            </div>
                                            <div v-if="header.text === 'Date'">
                                                {{ row.created_at | fromNow }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <!-- past title -->
                                <div
                                    v-if="data[4].length"
                                    class="pt-2 pb-2 pl-2 font-bold"
                                >
                                    {{ $t('LBL_PAST') }}
                                </div>
                                <!-- past bills -->
                                <tbody
                                    v-for="(row, rowIndex) in data[4]"
                                    :key="rowIndex"
                                    :class="[tbodyClass, rowIndex % 2 === 0 ? 'bg-gray-200' : '']"
                                >
                                    <tr
                                        v-for="header in headers"
                                        :key="header.text"
                                        :class="trClass"
                                        @click="goto('account.show', { orderId: row.bill_number })"
                                    >
                                        <th class="pl-1 text-sm font-semibold text-left text-gray-600 uppercase">
                                            {{ header.text }}
                                        </th>

                                        <td :class="[tdClass, 'relative']">
                                            <div v-if="header.text === 'Retailer Name'">
                                                {{ row.user.name }}
                                            </div>
                                            <div v-if="header.text === 'Items Sold'">
                                                {{ row.transactions.length }}
                                            </div>
                                            <div v-if="header.text === 'Sales Amount'">
                                                {{ config(common.currency) }}
                                                {{ sumAmountFromTransactions(row.transactions) }}
                                            </div>
                                            <div v-if="header.text === 'Date'">
                                                {{ row.created_at | fromNow }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                            <template v-else>
                                <tbody :class="tbodyClass">
                                    <!-- today title -->
                                    <tr
                                        v-if="data[0].length"
                                        :class="trClass"
                                        class="font-bold"
                                    >
                                        <td
                                            :class="tdClass"
                                            :colspan="5"
                                        >
                                            {{ $t('LBL_TODAY') }}
                                        </td>
                                    </tr>
                                    <!-- today's bills -->
                                    <tr
                                        v-for="bill in data[0]"
                                        :key="'bill-' + bill.id"
                                        :class="[trClass, bill.delivery_status === 'Placed' ? 'bg-red-100' :
                                            bill.delivery_status === 'Packed' ? 'bg-yellow-100' :
                                            bill.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-green-100', 'text-xs md:text-base']"
                                        class="cursor-pointer"
                                        @click="goto('account.show', { orderId: bill.bill_number })"
                                    >
                                        <!-- Retailer Name -->
                                        <td :class="tdClass">
                                            {{ bill.user.name }}
                                        </td>
                                        <!-- transaction count -->
                                        <td :class="tdClass">
                                            {{ bill.transactions.length }}
                                        </td>
                                        <!-- total transaction amount -->
                                        <td :class="[tdClass, 'text-green-500 font-semibold']">
                                            {{ config(common.currency) }} {{ sumAmountFromTransactions(bill.transactions) }}
                                        </td>
                                        <!-- Order Status  -->
                                        <td :class="tdClass">
                                            <div
                                                :class="bill.delivery_status === 'Placed' ? 'bg-red-400' :
                                                    bill.delivery_status === 'Packed' ? 'bg-yellow-400' :
                                                    bill.delivery_status === 'Shipped' ? 'bg-blue-400' : 'bg-green-400'"
                                                class="inline-block px-2 py-1 mt-1 text-sm text-white rounded"
                                            >
                                                {{ bill.delivery_status }}
                                            </div>
                                        </td>
                                        <!-- Date  -->
                                        <td :class="tdClass">
                                            {{ bill.created_at | fromNow }}
                                        </td>
                                    </tr>

                                    <!-- yesterday title -->
                                    <tr
                                        v-if="data[1].length"
                                        :class="trClass"
                                        class="font-bold"
                                    >
                                        <td
                                            :class="tdClass"
                                            :colspan="5"
                                        >
                                            {{ $t('LBL_YESTERDAY') }}
                                        </td>
                                    </tr>
                                    <!-- yesterday's bills -->
                                    <tr
                                        v-for="bill in data[1]"
                                        :key="'bill-' + bill.id"
                                        :class="[trClass, bill.delivery_status === 'Placed' ? 'bg-red-100' :
                                            bill.delivery_status === 'Packed' ? 'bg-yellow-100' :
                                            bill.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-green-100', 'text-xs md:text-base']"
                                        class="cursor-pointer"
                                        @click="goto('account.show', { orderId: bill.bill_number })"
                                    >
                                        <!-- Retailer Name -->
                                        <td :class="tdClass">
                                            {{ bill.user.name }}
                                        </td>
                                        <!-- transaction count -->
                                        <td :class="tdClass">
                                            {{ bill.transactions.length }}
                                        </td>
                                        <!-- total transaction amount -->
                                        <td :class="[tdClass, 'text-green-500 font-semibold']">
                                            {{ config(common.currency) }} {{ sumAmountFromTransactions(bill.transactions) }}
                                        </td>
                                        <!-- Order Status  -->
                                        <td :class="tdClass">
                                            <div
                                                :class="bill.delivery_status === 'Placed' ? 'bg-red-400' :
                                                    bill.delivery_status === 'Packed' ? 'bg-yellow-400' :
                                                    bill.delivery_status === 'Shipped' ? 'bg-blue-400' : 'bg-green-400'"
                                                class="inline-block px-2 py-1 mt-1 text-sm text-white rounded"
                                            >
                                                {{ bill.delivery_status }}
                                            </div>
                                        </td>
                                        <!-- Date  -->
                                        <td :class="tdClass">
                                            {{ bill.created_at | fromNow }}
                                        </td>
                                    </tr>

                                    <!-- this week title -->
                                    <tr
                                        v-if="data[2].length"
                                        :class="trClass"
                                        class="font-bold"
                                    >
                                        <td
                                            :class="tdClass"
                                            :colspan="5"
                                        >
                                            {{ $t('LBL_THIS_WEEK') }}
                                        </td>
                                    </tr>
                                    <!-- this week's bills -->
                                    <tr
                                        v-for="bill in data[2]"
                                        :key="'bill-' + bill.id"
                                        :class="[trClass, bill.delivery_status === 'Placed' ? 'bg-red-100' :
                                            bill.delivery_status === 'Packed' ? 'bg-yellow-100' :
                                            bill.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-green-100', 'text-xs md:text-base']"
                                        class="cursor-pointer"
                                        @click="goto('account.show', { orderId: bill.bill_number })"
                                    >
                                        <!-- Retailer Name -->
                                        <td :class="tdClass">
                                            {{ bill.user.name }}
                                        </td>
                                        <!-- transaction count -->
                                        <td :class="tdClass">
                                            {{ bill.transactions.length }}
                                        </td>
                                        <!-- total transaction amount -->
                                        <td :class="[tdClass, 'text-green-500 font-semibold']">
                                            {{ config(common.currency) }} {{ sumAmountFromTransactions(bill.transactions) }}
                                        </td>
                                        <!-- Order Status  -->
                                        <td :class="tdClass">
                                            <div
                                                :class="bill.delivery_status === 'Placed' ? 'bg-red-400' :
                                                    bill.delivery_status === 'Packed' ? 'bg-yellow-400' :
                                                    bill.delivery_status === 'Shipped' ? 'bg-blue-400' : 'bg-green-400'"
                                                class="inline-block px-2 py-1 mt-1 text-sm text-white rounded"
                                            >
                                                {{ bill.delivery_status }}
                                            </div>
                                        </td>
                                        <!-- Date  -->
                                        <td :class="tdClass">
                                            {{ bill.created_at | fromNow }}
                                        </td>
                                    </tr>

                                    <!-- last week title -->
                                    <tr
                                        v-if="data[3].length"
                                        :class="trClass"
                                        class="font-bold"
                                    >
                                        <td
                                            :class="tdClass"
                                            :colspan="5"
                                        >
                                            {{ $t('LBL_LAST_WEEK') }}
                                        </td>
                                    </tr>
                                    <!-- last week's bills -->
                                    <tr
                                        v-for="bill in data[3]"
                                        :key="'bill-' + bill.id"
                                        :class="[trClass, bill.delivery_status === 'Placed' ? 'bg-red-100' :
                                            bill.delivery_status === 'Packed' ? 'bg-yellow-100' :
                                            bill.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-green-100', 'text-xs md:text-base']"
                                        class="cursor-pointer"
                                        @click="goto('account.show', { orderId: bill.bill_number })"
                                    >
                                        <!-- Retailer Name -->
                                        <td :class="tdClass">
                                            {{ bill.user.name }}
                                        </td>
                                        <!-- transaction count -->
                                        <td :class="tdClass">
                                            {{ bill.transactions.length }}
                                        </td>
                                        <!-- total transaction amount -->
                                        <td :class="[tdClass, 'text-green-500 font-semibold']">
                                            {{ config(common.currency) }} {{ sumAmountFromTransactions(bill.transactions) }}
                                        </td>
                                        <!-- Order Status  -->
                                        <td :class="tdClass">
                                            <div
                                                :class="bill.delivery_status === 'Placed' ? 'bg-red-400' :
                                                    bill.delivery_status === 'Packed' ? 'bg-yellow-400' :
                                                    bill.delivery_status === 'Shipped' ? 'bg-blue-400' : 'bg-green-400'"
                                                class="inline-block px-2 py-1 mt-1 text-sm text-white rounded"
                                            >
                                                {{ bill.delivery_status }}
                                            </div>
                                        </td>
                                        <!-- Date  -->
                                        <td :class="tdClass">
                                            {{ bill.created_at | fromNow }}
                                        </td>
                                    </tr>

                                    <!-- past title -->
                                    <tr
                                        v-if="data[4].length"
                                        :class="trClass"
                                        class="font-bold"
                                    >
                                        <td
                                            :class="tdClass"
                                            :colspan="5"
                                        >
                                            {{ $t('LBL_PAST') }}
                                        </td>
                                    </tr>
                                    <!-- past bills -->
                                    <tr
                                        v-for="bill in data[4]"
                                        :key="'bill-' + bill.id"
                                        :class="[trClass, bill.delivery_status === 'Placed' ? 'bg-red-100' :
                                            bill.delivery_status === 'Packed' ? 'bg-yellow-100' :
                                            bill.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-green-100', 'text-xs md:text-base']"
                                        class="cursor-pointer"
                                        @click="goto('account.show', { orderId: bill.bill_number })"
                                    >
                                        <!-- Retailer Name -->
                                        <td :class="tdClass">
                                            {{ bill.user.name }}
                                        </td>
                                        <!-- transaction count -->
                                        <td :class="tdClass">
                                            {{ bill.transactions.length }}
                                        </td>
                                        <!-- total transaction amount -->
                                        <td :class="[tdClass, 'text-green-500 font-semibold']">
                                            {{ config(common.currency) }} {{ sumAmountFromTransactions(bill.transactions) }}
                                        </td>
                                        <!-- Order Status  -->
                                        <td :class="tdClass">
                                            <div
                                                :class="bill.delivery_status === 'Placed' ? 'bg-red-400' :
                                                    bill.delivery_status === 'Packed' ? 'bg-yellow-400' :
                                                    bill.delivery_status === 'Shipped' ? 'bg-blue-400' : 'bg-green-400'"
                                                class="inline-block px-2 py-1 mt-1 text-sm text-white rounded"
                                            >
                                                {{ bill.delivery_status }}
                                            </div>
                                        </td>
                                        <!-- Date  -->
                                        <td :class="tdClass">
                                            {{ bill.created_at | fromNow }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </template>
                    </t-table>
                    <div
                        v-if="!allDetails.bills.length"
                        class="my-10 w-100 text-center"
                    >
                        {{ $t('LBL_DATA_FOUND') }}
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import moment from 'moment';
import AdminIcon from '../../Components/Icons/AdminIcon.vue';
import WholesalerIcon from '../../Components/Icons/WholesalerIcon.vue';
import RetailerIcon from '../../Components/Icons/RetailerIcon.vue';
import AppLayout from '../../Layouts/AppLayout.vue';
import ProductIcon from '../../Components/Icons/ProductIcon.vue';
import CategoryIcon from '../../Components/Icons/CategoryIcon.vue';
import BrandIcon from '../../Components/Icons/BrandIcon.vue';
import common from '../../common';
import PeopleIcon from '../../Components/Icons/PeopleIcon.vue';
import ClockIcon from '../../Components/Icons/ClockIcon.vue';

export default {
    name: 'AccountInformation',

    components: {
        AppLayout,
        ProductIcon,
        CategoryIcon,
        BrandIcon,
        PeopleIcon,
        ClockIcon,
        AdminIcon,
        WholesalerIcon,
        RetailerIcon,
    },

    props: {
        allDetails: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            common,
            filterBy: 'allTime',
            filterByOptions: [
                { name: 'All Time', value: 'allTime' },
                { name: 'Current Week', value: 'currentWeek' },
                { name: 'Current Month', value: 'currentMonth' },
                { name: 'Current Year', value: 'currentYear' },
                { name: 'Last Year', value: 'lastYear' },
            ],
            dateRange: [],
            mounted: false,
        };
    },

    computed: {
        greetings() {
            const d = new Date();
            const time = d.getHours();
            let greeting = '';

            if (time < 12) {
                greeting = 'Good morning,';
            }
            if (time >= 12) {
                greeting = 'Good afternoon,';
            }
            if (time > 16) {
                greeting = 'Good evening,';
            }
            return greeting;
        },
    },

    watch: {
        dateRange: {
            handler(newVal) {
                if (newVal.length === 2 && this.mounted) {
                    this.$inertia.get(
                        route('dashboard', { from: this.dateRange[0], to: this.dateRange[1], filterBy: this.filterBy })
                    );
                }
            },
        },

        filterBy: {
            handler() {
                if (this.mounted) {
                    this.$inertia.get(
                        route('dashboard', { from: this.dateRange[0], to: this.dateRange[1], filterBy: this.filterBy })
                    );
                }
            },
        },
    },

    mounted() {
        if (this.allDetails.filtersApplied.from && this.allDetails.filtersApplied.to) {
            this.dateRange = [this.allDetails.filtersApplied.from, this.allDetails.filtersApplied.to];
        }
        if (this.allDetails.filtersApplied.filterBy) {
            this.filterBy = this.allDetails.filtersApplied.filterBy;
        }
        // wait for a sec so that the watch for dateRange doesn't get executed on mounted hook
        this.sleep(1000).then(() => {
            this.mounted = true;
        });
    },

    methods: {
        sumAmountFromTransactions(transactions) {
            let sumGrandTotal = 0;
            transactions.forEach((transaction) => {
                sumGrandTotal += parseFloat(transaction.grand_total);
            });
            return sumGrandTotal.toFixed(2);
        },

        groupedBills() {
            const groupedBills = [
                [], // today
                [], // yesterday
                [], // thisWeek
                [], // lastWeek
                [], // past
            ];

            const today = moment();
            const yesterday = moment().subtract(1, 'day');

            this.allDetails.bills.forEach((bill) => {
                if (moment(bill.created_at).isSame(today, 'day')) {
                    groupedBills[0].push(bill);
                } else if (moment(bill.created_at).isSame(yesterday, 'day')) {
                    groupedBills[1].push(bill);
                } else if (moment(bill.created_at).week() === moment().week()) {
                    groupedBills[2].push(bill);
                } else if (
                    moment(bill.created_at).week()
                    === moment()
                        .subtract(1, 'week')
                        .week()
                ) {
                    groupedBills[3].push(bill);
                } else {
                    groupedBills[4].push(bill);
                }
            });

            return groupedBills;
        },
    },
};
</script>
